<script>
  export default {
    name: 'PanelRow',
    props: {
      tag: {
        default: 'div',
      },
    },
    render (el) {
      return el(this.tag, {
        class: 'panel-row',
      }, [
        this.$slots.default,
      ]);
    }
  }
</script>

<style lang="scss">
  .panel-row {
    display: flex;
    align-items: stretch;
    margin: 0;
    flex-wrap: wrap;
    &.oneline {
      @media (min-width: $min-lg) {
        flex-wrap: nowrap;
      }
    }
    > nav {
      text-align: center;
      width: 100%;
    }
  }
  h1.panel-row {
    overflow: hidden;
    @include font-size(32px, 43px);
    font-weight: 400;
    letter-spacing: 0.03em;
    .panel {
      padding-top: 8px;
      padding-bottom: 8px;
    }
    @media (min-width: $lg-min) {
      &::after {
        content: '';
        display: inline-block;
        flex-grow: 1;
        margin: $panel-margin;
        background: $default-bg;
        @include panel-shadow;
      }
    }
    /*.panel, &::after {
      transform-origin: left bottom;
      transform: skewX(-20deg);
    }*/
  }
</style>



// WEBPACK FOOTER //
// src/helpers/components/panels/PanelRow.vue